// TODO: use Lens prefix
export const grafanaBasePrefix = "WebStories";
